//@flow
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./slider.css";
import Player from "./components/radioplayer";
import * as serviceWorker from "./serviceWorker";




// if (!process.env.REACT_APP_STREAM_URL ||
// !process.env.REACT_APP_METASERVER_URL) {   throw new
// Error("ENV URLs NOT SET"); }
const root = document.getElementById("root") || null;
if (root) ReactDOM.render(<Player />, root);

// If you want your app to work offline and load faster, you
// can change unregister() to register() below. Note this
// comes with some pitfalls. Learn more about service
// workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
